export default __webpack_public_path__ + "static/media/hra-card-icon.5fbcf5fb.svg";